import { PAGE_TYPE } from '@/constants/index'
import { useStore } from '@/store/index'
import { openConfirmModal } from '@gate/gui'
import { useMemoizedFn } from 'ahooks'
import { useTranslation } from 'next-i18next'
import { useOpenLoginPage } from '@gateio/core-lib'
import { useMemo } from 'react'

const useModalLogin = () => {
  const { pageType } = useStore().coinDetailsStore
  const { t } = useTranslation(pageType === PAGE_TYPE.COIN_DETAIL ? ['coin_details_v2'] : [])
  const login = useOpenLoginPage()

  /**
   * @description: 登录翻译key值替换
   * @param {*} useMemo
   * @return {*}
   */
  const loginInfo = useMemo(() => {
    if (pageType === PAGE_TYPE.COIN_DETAIL) {
      return {
        loginTitle: 'PleaseLogin',
        cancel: 'Cancel',
        Login: 'Login',
      }
    }

    return {
      loginTitle: 'P.PleaseLogin',
      cancel: 'P.Cancel',
      Login: 'P.Login',
    }
  }, [pageType])

  const openLoginModal = useMemoizedFn(
    () =>
      void openConfirmModal({
        styles: {
          header: {
            display: 'none',
          },
          body: {
            '.mantine-Group-root': {
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              gap: '24px',
            },
            '.mantine-Button-root': {
              marginTop: '8px',
              borderRadius: '18px',
              width: 'calc(50% - 12px)',
            },
          },
        },
        padding: 24,
        centered: true,
        children: (
          <span
            style={{ textAlign: 'center', width: '100%', display: 'block' }}
            className="text-1 font-700 size-16 line-120"
            // dir={locale === 'ar' ? 'rtl' : undefined}
          >
            {t(loginInfo.loginTitle)}
          </span>
        ),
        labels: { cancel: `${t(loginInfo.cancel)}`, confirm: `${t(loginInfo.Login)}` },
        onConfirm: login,
        // onCancel: () => console.log('Confirmed'),
      })
  )

  return { openLoginModal }
}

export default useModalLogin
